// @flow
import axios from 'lib/defaultClient';

export const getTempSaveList = (bannerId: string) => axios.get(`/banners/${bannerId}/saves`);

export type LoadTempSavePayload = {
  bannerId: string,
  saveId: string,
};

export const loadTempSave = ({ bannerId, saveId }: LoadTempSavePayload) => {
  return axios.get(`/banners/${bannerId}/saves/${saveId}`);
};



// WEBPACK FOOTER //
// ./src/lib/api/banners/saves.js